import React from "react";
import { useTranslation } from "react-i18next";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { JPInputTipsProps } from "./jpInputTips.model";
import "@companion-core/web/src/Assets/Styles/scss/inputtips.scss";

export const JPInputTips: React.FC<JPInputTipsProps> = ({
  tip,
  icon,
  testID,
  id,
}: JPInputTipsProps) => {
  const { t } = useTranslation();

  return (
    <div id={id} data-testid={`${testID}--tips`} className="JPInputTips">
      {icon && <FontIcon name={icon} size={20} className="JPInputTips__icon-tips" />}
      <span className="body-text-8">{t(`${tip}`)}</span>
    </div>
  );
};
